export interface Country {
    iso2: string
    name: string
    callingCode: `+${string}`
}

export interface ShopifyCountry {
    iso2: string
    name: string
}

import data from './countries.en.json' assert { type: 'json' }
export const countriesEn = data as Country[]


import shopifyData from './countries.shopify.json' assert { type: 'json' }
export const countriesShopify = shopifyData.filter(c => c.iso2 !== 'ZZ') as ShopifyCountry[]

export const countriesShopifyWithGlobal = shopifyData;

import slugData from './countries.slugs.json' assert { type: 'json' };

/**
 * Map from country slug to ISO2 code
 * e.g., "united-states" -> "US"
 */
export const slugToIso2 = slugData.slugToIso2 as Record<string, string>

/**
 * Map from ISO2 code to country slug
 * e.g., "US" -> "united-states"
 */
export const iso2ToSlug = slugData.iso2ToSlug as Record<string, string>

/**
 * Get ISO2 country code from a country slug
 * 
 * @param slug - The country slug (e.g., "united-states", "canada")
 * @returns The ISO2 country code or undefined if not found
 */
export function getCountryCodeFromSlug(slug: string): string | undefined {
    return slugToIso2[slug]
}

/**
 * Get country slug from ISO2 code
 * 
 * @param iso2 - The ISO2 country code (e.g., "US")
 * @returns The country slug or undefined if not found
 */
export function getSlugFromCountryCode(iso2: string): string | undefined {
    return iso2ToSlug[iso2.toUpperCase()]
}

export function flagUrl(iso2: string): string {
    return new URL(`./flags/${iso2.toUpperCase()}.svg`, import.meta.url).toString()
}

export const byIso2 = Object.fromEntries(
    countriesShopifyWithGlobal.map(c => [c.iso2, c])
) as Record<string, Country>

export const byCalling = countriesEn.reduce<Record<string, Country[]>>((acc, c) => {
    (acc[c.callingCode] ||= []).push(c)
    return acc
}, {})